'use client'
import React, { useEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import Link from 'next/link'

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

function WhyChooseUs() {
   const panelsRef = useRef(null)
   const containerRef = useRef(null)

   useEffect(() => {
      if (!panelsRef.current || !containerRef.current) return

      const panels = gsap.utils.toArray('#panels-container .panel')

      const tween = gsap.to(panels, {
         xPercent: -100 * (panels.length - 1),
         ease: 'none',
         scrollTrigger: {
            trigger: containerRef.current,
            pin: true,
            scrub: 1,
            start: 'top top',
            end: () =>
               '+=' + (containerRef.current.scrollWidth - window.innerWidth),
         },
      })

      const refresh = () => ScrollTrigger.refresh()
      window.addEventListener('load', refresh)

      return () => {
         window.removeEventListener('load', refresh)
         tween.scrollTrigger?.kill()
      }
   }, [])

   return (
      <>
         <section className="gsap-scroll pt-0 pb-0 show-desktop">
            <div id="page" className="site">
               <main id="content" className="site-content" role="main">
                  <div id="panels" className="pt-0 pb-0" ref={panelsRef}>
                     <div
                        id="panels-container"
                        ref={containerRef}
                        style={{ width: '400%' }}
                     >
                        {/* Panel 1 */}
                        <article
                           id="panel-1"
                           className="panel full-screen gradient-green"
                        >
                           <div>
                              <h2 className="why-choose-text tech_title mb-3 d-block text-center">
                                 Why
                                 <br />
                                 Choose Us?
                              </h2>
                           </div>
                        </article>

                        {/* Panel 2 */}
                        <article
                           id="panel-2"
                           className="panel full-screen gradient-blue"
                        >
                           <div className="Homeinnovation_card_main">
                              <div className="row g-4 home-grid">
                                 {[
                                    {
                                       value: '200+',
                                       label: 'Projects Completed',
                                    },
                                    { value: '25+', label: 'countries served' },
                                    {
                                       value: '12+',
                                       label: 'Years Experiences',
                                    },
                                    { value: '50+', label: 'Developers Team' },
                                    {
                                       value: '95%',
                                       label: 'talent retention rate',
                                    },
                                    { value: '0%', label: 'Office Drama' },
                                 ].map((item, index) => (
                                    <div
                                       key={index}
                                       className={`col-lg-4 col-6 home-card-wrapper ${
                                          index < 3 ? 'line-before' : ''
                                       } d-flex justify-content-center`}
                                    >
                                       <div className="home-stats">
                                          <div className="top_section_heading why-choose-top_section_heading">
                                             {item.value}
                                          </div>
                                          <div className="stat-text">
                                             {item.label}
                                          </div>
                                       </div>
                                    </div>
                                 ))}
                              </div>
                           </div>
                        </article>

                        {/* Panel 3 */}
                        <article
                           id="panel-3"
                           className="panel full-screen gradient-green"
                        >
                           <div>
                              <p className="panel-small-title">
                                 Have a project in mind
                              </p>
                              <h2 className="panel3-title tech_title my-4">
                                 Let's Make Something <br />
                                 Great Together!
                              </h2>
                              <div className="d-flex justify-content-center">
                                 <Link
                                    href="/discover-benzatine/contact-us"
                                    className="home-contact-btn"
                                 >
                                    <span>CONTACT US</span>
                                    <svg
                                       className="arrow-icon"
                                       width="36"
                                       height="19"
                                       viewBox="0 0 36 19"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M35.766 9.15325L27.5843 0.971548C27.2904 0.628359 26.7739 0.588352 26.4307 0.882323C26.0876 1.17622 26.0475 1.69273 26.3415 2.03592C26.369 2.06798 26.3987 2.09772 26.4307 2.12514L33.2133 8.91595H0.822048C0.370228 8.91595 0.00390625 9.28227 0.00390625 9.73416C0.00390625 10.186 0.370228 10.5523 0.822048 10.5523H33.2133L26.4307 17.3349C26.0876 17.6288 26.0475 18.1453 26.3415 18.4885C26.6355 18.8317 27.1519 18.8717 27.4951 18.5777C27.5272 18.5502 27.5569 18.5205 27.5843 18.4885L35.766 10.3068C36.0832 9.98777 36.0832 9.47239 35.766 9.15325Z"></path>
                                    </svg>
                                 </Link>
                              </div>
                           </div>
                        </article>
                     </div>
                  </div>
               </main>
            </div>
         </section>

         <section className="section_secondary_bg show-responsive">
            <div className="container">
               <article className="panel gradient-green pt-0">
                  <div>
                     <h2 className="why-choose-text tech_title mb-3 d-block text-center">
                        Why Choose Us?
                     </h2>
                  </div>
               </article>
               <article className="panel-2 gradient-blue">
                  <div>
                     <div className="Homeinnovation_card_main">
                        <div className="row g-4 home-grid">
                           <div className="col-lg-4 col-6 home-card-wrapper line-before d-flex justify-content-center">
                              <div className="home-stats">
                                 <div className="top_section_heading why-choose-top_section_heading">
                                    200+
                                 </div>
                                 <div className="stat-text">
                                    Projects Completed
                                 </div>
                              </div>
                           </div>

                           <div className="col-lg-4 col-6 home-card-wrapper line-before d-flex justify-content-center">
                              <div className="home-stats">
                                 <div className="top_section_heading why-choose-top_section_heading">
                                    25+
                                 </div>
                                 <div className="stat-text">
                                    countries served
                                 </div>
                              </div>
                           </div>

                           <div className="col-lg-4 col-6 home-card-wrapper line-before d-flex justify-content-center">
                              <div className="home-stats">
                                 <div className="top_section_heading why-choose-top_section_heading">
                                    12+
                                 </div>
                                 <div className="stat-text">
                                    Years Experiences
                                 </div>
                              </div>
                           </div>

                           <div className="col-lg-4 col-6 home-card-wrapper d-flex line-before justify-content-center">
                              <div className="home-stats">
                                 <div className="top_section_heading why-choose-top_section_heading">
                                    50+
                                 </div>
                                 <div className="stat-text">
                                    Developers Team
                                 </div>
                              </div>
                           </div>

                           <div className="col-lg-4 col-6 home-card-wrapper d-flex justify-content-center">
                              <div className="home-stats">
                                 <div className="top_section_heading why-choose-top_section_heading">
                                    95%
                                 </div>
                                 <div className="stat-text">
                                    talent retention rate
                                 </div>
                              </div>
                           </div>

                           <div className="col-lg-4 col-6 home-card-wrapper d-flex justify-content-center">
                              <div className="home-stats">
                                 <div className="top_section_heading why-choose-top_section_heading">
                                    0%
                                 </div>
                                 <div className="stat-text">Office Drama</div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </article>
               <article className="panel gradient-green mt-sm-5 mt-4">
                  <div>
                     <p className="panel-small-title">Have a project in mind</p>
                     <h2 className="panel3-title tech_title my-4">
                        Let's Make Something <br />
                        Great Together!
                     </h2>
                     <div className="d-flex justify-content-center">
                        <Link
                           // href="/discover-benzatine/contact-us"
                           href="/discover-benzatine/contact-us"
                           className="home-contact-btn"
                           aria-label="Contact Us"
                        >
                           <span>CONTACT US</span>
                           <svg
                              className="arrow-icon"
                              width="36"
                              height="19"
                              viewBox="0 0 36 19"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path d="M35.766 9.15325L27.5843 0.971548C27.2904 0.628359 26.7739 0.588352 26.4307 0.882323C26.0876 1.17622 26.0475 1.69273 26.3415 2.03592C26.369 2.06798 26.3987 2.09772 26.4307 2.12514L33.2133 8.91595H0.822048C0.370228 8.91595 0.00390625 9.28227 0.00390625 9.73416C0.00390625 10.186 0.370228 10.5523 0.822048 10.5523H33.2133L26.4307 17.3349C26.0876 17.6288 26.0475 18.1453 26.3415 18.4885C26.6355 18.8317 27.1519 18.8717 27.4951 18.5777C27.5272 18.5502 27.5569 18.5205 27.5843 18.4885L35.766 10.3068C36.0832 9.98777 36.0832 9.47239 35.766 9.15325Z"></path>
                           </svg>
                        </Link>
                     </div>
                  </div>
               </article>
            </div>
         </section>
      </>
   )
}

export default WhyChooseUs
